/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState, useEffect } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import getCroppedImg from "../../utils/cropImage";
import useSaveTemplate from "../../utils/customHooks";
import ImageUploader from "../../utils/ImageUploader";
import { CropperWrapper } from "../../utils/CropperWrapper";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

export const Basnie31: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("MAGICZNA KSIĘGA BAŚNI");
  const [text2, setText2] = useState<string>("spisana dla Bartusia");
  const [text3, setText3] = useState<string>('"Kiedy śmieje się dziecko,');
  const [text4, setText4] = useState<string>('śmieje się cały świat"');
  const [text5, setText5] = useState<string>("59 cm radości");

  const text1BasicSize = 45;
  const text2BasicSize = 93;
  const text3BasicSize = 32;
  const text4BasicSize = 32;
  const text5BasicSize = 32;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 850; // Maximum width for text
  const maxWidth2 = 350;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'PLZurichItalic'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'PLZurichItalic'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'PLZurichItalic'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

    const adjustFontSize2 = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'PLZurichItalic'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth2 && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'PLZurichItalic'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth2 * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'PLZurichItalic'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize2(text3, fontSizeText3, text3BasicSize, 10));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize2(text4, fontSizeText4, text4BasicSize, 10));
  }, [text4]);

  useEffect(() => {
    setFontSizeText5(adjustFontSize2(text5, fontSizeText5, text5BasicSize, 10));
  }, [text5]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };
  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (<div style={{
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff", padding: "60px",
    position: "relative",
  }}>
    {/* Spinner Overlay */}
    <SpinnerOverlay isVisible={isSaving} />
    <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
      <ImageUploader
        onImageChange={(image) => setImage(image)}
        setStep={setStep}
      />
      {step === "crop" && (
        <p>
          Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
        </p>
      )}
      {step !== "crop" && (
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      )}
      {step === "crop" && (
        <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
      )}
    </div>

    <div
      id="printable-content"
      style={{
        position: "relative",
        width: pdfWidth,
        height: pdfHeight,
        fontFamily: "Arial, PLZurich, GreatVibes, PLZurichItalic",
        backgroundColor: "#ffffff",
        margin: "auto",
        marginTop: "20px"
      }}
    >          <InlineEdit
        value={text1}
        setValue={setText1}
        style={{
          fontSize: `${fontSizeText1}px`,
          lineHeight: `${fontSizeText1}px`,
          width: `${maxWidth}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          top: '236px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '0',
          fontFamily: 'Arial',
          color: "#8b6f45",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "800",
        }}
      />
      <InlineEdit
        value={text2}
        setValue={setText2}
        style={{
          fontSize: `${fontSizeText2}px`,
          lineHeight: `${fontSizeText2}px`,
          width: `${maxWidth}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          top: '315px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '0',
          fontFamily: 'GreatVibes',
          color: "#ba9962",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "400",
        }}
      />
      <InlineEdit
        value={text3}
        setValue={setText3}
        style={{
          fontSize: `${fontSizeText3}px`,
          lineHeight: `${fontSizeText3}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '300px', // Zmienione położenie
          margin: 'auto',
          // left: '106px',
          right: '40px',
          width: "350px",
          fontFamily: 'PLZurichItalic',
          color: "#4a2f1f",
          zIndex: "12",
          textAlign: "center",
        }}
      />

      <InlineEdit
        value={text4}
        setValue={setText4}
        style={{
          fontSize: `${fontSizeText4}px`,
          lineHeight: `${fontSizeText4}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '260px', // Zmienione położenie
          margin: 'auto',
          // left: '0px',
          right: '40px',
          width: "350px",
          fontFamily: 'PLZurichItalic',
          color: "#4a2f1f",
          zIndex: "12",
          textAlign: "center",
        }}
      />
      {/* Step: Crop */}
      {image && step === "crop" && (
        <CropperWrapper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={420 / 378}
          cropShape="round"
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          style={{
            top: "450px",
            left: "480px",
            width: "420px",
            height: "387px",
            zIndex: 5,
            clipPath: "polygon(53% 100%, 89% 69%, 100% 31%, 91% 5%, 64% 3%, 52% 14%, 46% 6%, 21% 1%, 0% 27%, 9% 59%)"
          }}
        />
      )}

      {/* Step: View */}
      {croppedImage && step === "view" && (
        <img
          src={croppedImage}
          style={{
            position: "absolute",
            top: "450px",
            left: "480px",
            width: "420px",
            height: "387px",
            transform: "translateX(-50%)",
            zIndex: 2,
            clipPath: "polygon(53% 100%, 89% 69%, 100% 31%, 91% 5%, 64% 3%, 52% 14%, 46% 6%, 21% 1%, 0% 27%, 9% 59%)"
          }}
        />
      )}

      <img
        src="/images/Basnie31.svg"
        style={{ width: "100%", height: "100%", position: "relative", zIndex: 3 }}
      />
    </div>
  </div>
  );
};